export const midnightNeutral = {
  50: '#E7EAF2',
  100: '#DADCE5',
  200: '#CFD2DB',
  300: '#BFC2CC',
  400: '#A2A6B2',
  500: '#818591',
  600: '#585D6B',
  700: '#424859',
  800: '#313645',
  900: '#232938',
  950: '#1A1F2E',
};

export const midnightPrimary = {
  50: '#E4EDFD',
  100: '#D4E0FC',
  200: '#BDCFFC',
  300: '#A2BBFC',
  400: '#86A4F0',
  500: '#6E8EE0',
  600: '#5C7AC4',
  700: '#4E66A3',
  800: '#3C4F80',
  900: '#2D3D66',
  950: '#263457',
};

export const midnightSecondary = {
  50: '#E8E4FD',
  100: '#DBD4FC',
  200: '#C9BDFC',
  300: '#B2A2FC',
  400: '#9A86F0',
  500: '#836EE0',
  600: '#6F5CC4',
  700: '#5E4EA3',
  800: '#483C80',
  900: '#372D66',
  950: '#2F2657',
};

export const midnightSuccess = {
  50: '#E4FDEF',
  100: '#D4FCE6',
  200: '#BDFCE8',
  300: '#A2FCE0',
  400: '#86F0CE',
  500: '#6EE0BC',
  600: '#5CC4A3',
  700: '#4EA388',
  800: '#3C806A',
  900: '#2D6654',
  950: '#265747',
};

export const midnightWarning = {
  50: '#FDF4E4',
  100: '#FCF0D4',
  200: '#FCE8BD',
  300: '#FCE0A2',
  400: '#F0CE86',
  500: '#E0BC6E',
  600: '#C4A35C',
  700: '#A3884E',
  800: '#806A3C',
  900: '#66542D',
  950: '#574726',
};

export const midnightError = {
  50: '#FDE4F2',
  100: '#FCD4EB',
  200: '#FCBDE1',
  300: '#FCA2D5',
  400: '#F086C2',
  500: '#E06EAF',
  600: '#C45C97',
  700: '#A34E7E',
  800: '#803C62',
  900: '#662D4D',
  950: '#572642',
};

export const midnightInfo = {
  50: '#E4F5FD',
  100: '#D4EFFC',
  200: '#BDE7FC',
  300: '#A2DEFC',
  400: '#86CDF0',
  500: '#6EBAE0',
  600: '#5CA2C4',
  700: '#4E87A3',
  800: '#3C6980',
  900: '#2D5366',
  950: '#264757',
};

export const midnightBg = {
  light: '#F2F4FB',
  dark: '#121829',
};

